import React, { useId, useState, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useAppDispatch } from 'store';
import { fileType } from 'store/reducers/attachments';
import { uploadDocument } from 'store/reducers/mediaSlice';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFToJPGConverter = ({
  pdf,
  receiverId,
  isPrivate,
  setPdfs,
}: {
  pdf: fileType;
  receiverId?: string;
  isPrivate?: boolean;
  setPdfs: React.Dispatch<React.SetStateAction<fileType[]>>;
}) => {
  const dispatch = useAppDispatch();
  const id = useId();
  const [numPages, setNumPages] = useState(null);
  const pageCanvasRef = useRef<HTMLCanvasElement>(null);

  // Function to handle document load success
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const convertToJPG = (canvas: HTMLCanvasElement) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return;

        const formData = pdf.formdata;
        formData.append('thumb', blob, id + '.png');

        dispatch(uploadDocument({ formdata: formData, receiverId, isPrivate, thumb: blob }));
        setPdfs((c) => c.filter((el) => el.fileName !== pdf.fileName));
      },
      'image/png',
      1,
    );
  };

  const onRenderSuccess = (canvasEl: HTMLCanvasElement) => {
    convertToJPG(canvasEl);
  };

  return (
    <div className="hidden">
      <Document file={pdf.renderUrl} onLoadSuccess={onDocumentLoadSuccess}>
        {numPages && (
          <Page
            pageNumber={1}
            scale={3}
            width={200}
            renderMode="canvas"
            canvasRef={pageCanvasRef}
            onRenderSuccess={() => onRenderSuccess(pageCanvasRef.current!)}
          />
        )}
      </Document>
    </div>
  );
};

export default PDFToJPGConverter;
